import React, { useState } from 'react';
import api from './api'

export default function AddLead() {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("access_token");  
    const [form, setForm] = useState({ business_name: '', owner_name: '', email: '' });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleChange = e => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = e => {
        e.preventDefault();
        setLoading(true);
        api.post(baseUrl + '/add-lead/', form, {
                    headers: { Authorization: `Bearer ${token}` },
                })
            .then(res => {
                setMessage(res.data.message);
                setLoading(false);
                setForm({ business_name: '', owner_name: '', email: '', mobile: '' });
            })
            .catch(err => {
                setMessage(err.response?.data?.message || 'Error adding lead.');
                setLoading(false);
            });
    };

    return (
        <section className="container mtopcon normal-mt-sctn">
                    <div className="row">
                        <div className="col-12 col-lg-4 reglogincon">
                            <div className="card shadow-none">
                                <div className="card-body">
                                    <h2 className='mb-3 text-center'><b>Add New Lead</b></h2>
                                    
                                    <form onSubmit={handleSubmit}>
                                        <input className="form-control mb-3" name="business_name" placeholder="Business Name" value={form.business_name} onChange={handleChange} />
                                        <input className="form-control mb-3" name="owner_name" placeholder="Owner Name" value={form.owner_name} onChange={handleChange} />
                                        <input className="form-control mb-3" name="email" placeholder="Email" type="email" value={form.email} onChange={handleChange} />
                                        <input className="form-control mb-3" name="mobile" placeholder="Mobile" type="number" value={form.mobile} onChange={handleChange} />
                                        <button className="col-12 btn btn-dark" type="submit" disabled={loading}>
                                            {loading ? 'Adding...' : 'Add Lead'}
                                        </button>
                                    </form>
                                    {message && <p className='text-center text-dark mt-3'><b>{message}</b></p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
    );
}
